<template>
  <div class="card" >
    <div class="card-title">
      <span>{{title || cardTypeMap.get(cardType)}}</span>
      <el-link :underline="false" @click="changeView(cardType)">查看更多<i class="el-icon-arrow-right"></i></el-link>
    </div>
    <el-row v-if="cardType == 2" v-loading="loading">
      <el-col :span="11" v-for="(item, index) in itemList" :key="index" :offset="index%2 > 0 ? 1 : 0" >
        <div class="card-info">
          <span class="card-info-title" @click="getDetail(item)">{{item.title}}</span>
          <span style="margin: 11px 0px 19px 0px">#{{item.tag ? item.tag.replace(/,/g,' #') : ''}}</span>
          <div style="display: flex;flex-flow: row;align-items: center">
            <span class="card-info-sec">
              {{item.section}}
            </span>
            <span style="margin: 0px 18px 0px 23px;">{{item.createdTime.split(' ')[0]}}</span>
            <span>阅读：{{item.readCount}}</span>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="cardType == 3" v-loading="loading">
      <div @mouseover="onEnter" @mouseleave="onLeave">
        <swiper :options="swiperOption" ref="mySwiper" v-if="itemList.length > 0">
          <swiper-slide v-for="(item, index) in itemList" :key="index" :data-id="item.id">
            <el-card :body-style="{ padding: '0px',cursor: 'pointer'}">
              <div>
                <img :src="item.image" width="100%" height="210px" style="object-fit:cover">
                <div class="card-cour">
                  <span class="card-cour-name">{{ item.name }}</span>
                  <div class="card-cour-hour">
                    <span>{{ item.intro || '暂无简介' }}</span>
                    <!--<span style="color: #EA4335;font-size: 16px;">zzz</span>-->
                  </div>
                </div>
              </div>
            </el-card>
          </swiper-slide>
        </swiper>
      </div>
    </el-row>
    <el-row v-else v-loading="loading">
      <el-col :span="5" v-for="(item, index) in itemList" :key="index" :offset="index%4 > 0 ? 1 : 0" >
        <el-card :body-style="{ padding: '0px',cursor: 'pointer'}">
          <div @click="getDetail(item)">
            <img :src="item.image" width="100%" height="210px" style="object-fit:cover">
            <div class="card-cour">
              <span class="card-cour-name">{{item.name}}</span>
              <div class="card-cour-hour">
                <span>学时：{{item.hours}}</span>
                <!--<span style="color: #EA4335;font-size: 16px;">￥{{parseFloat(item.price).toFixed(2)}}</span>-->
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  let _this
  export default {
    name: "Card",
    props:{
      loading: Boolean,
      cardType: String,
      itemList: Array,
      title: String
    },
    data() {
      return {
        cardTypeMap: new Map([
          ['0', '技术人员培训学习'],
          ['1', '技术人员宣贯学习'],
          ['2', '资讯'],
          ['3', '名师介绍'],
        ]),
        // 轮播属性设置
        swiperOption: {
          autoplay: {
            delay: 4000,
          }, // 自动播放
          loop : true,
          slidesPerView: 4,
          spaceBetween: 24,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          on: {
            click: function() {
              const id = this.clickedSlide.dataset.id
              const params = {
                teacherId: id
              };
              let routeUrl = _this.$router.resolve({ name: 'TeacherDetail', params: params });
              window.open(routeUrl.href, '_blank');
            }
          }
        }
      }
    },
    created() {
      _this = this
    },
    computed: {
      myBotSwiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    methods:{
      onEnter() {
        this.myBotSwiper.autoplay.stop()
      },
      onLeave() {
        this.myBotSwiper.autoplay.start()
      },
      changeView(type){
        switch (this.cardType) {
          case '0':
            this.$router.push('/home/trainList')
            break;
          case '1':
            this.$router.push('/home/eduList')
            break;
          case '2':
            this.$router.push('/home/information')
            break;
          case '3':
            this.$router.push('/home/teacherList')
            break;
        }
      },
      getDetail(item){
        console.log(this.cardType)
        let routerMyCard;
        switch (this.cardType) {
          case '0':
            routerMyCard = this.$router.resolve('/home/trainDetail/'+item.id);
            window.open(routerMyCard.href,'_blank')
            break;
          case '1':
            routerMyCard = this.$router.resolve('/home/eduDetail/'+item.id);
            window.open(routerMyCard.href,'_blank')
            break;
          case '2':
            routerMyCard = this.$router.resolve({path:'/home/article/',query:{id: item.id}});
            window.open(routerMyCard.href,'_blank')
            break;
          case '3':
            const params = {
              teacherId: item.id
            };
            let routeUrl = this.$router.resolve({ name: 'TeacherDetail', params: params });
            window.open(routeUrl.href, '_blank');
            break;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .swiper-container {
    padding-top: 10px;
    margin-top: -10px;
  }
  .card{
    width: 1200px;
    margin: 0px auto;
    padding-top: 44px;
    font-size: 14px;
    color: #333333;
  }
  .card+.card{
    padding-top: 4px;
  }
  .card-title{
    display:flex;
    align-items:center;
    padding: 15px 30px;
    background-color: #F0F3F6;
    margin-bottom: 26px;
    justify-content:space-between;
    line-height: 30px;
    font-size: 22px;
    font-weight: bold;
    color: #606266;
  }
  .card-info{
    display: flex;
    flex-flow: column;
    color: #999999;
    line-height: 14px;
    margin-bottom: 21px;
    padding-bottom: 18px;
    border-bottom: solid 1px #E0E0E0;
  }
  .card-info-title{
    cursor: pointer;
    max-width: 588px;
    width: fit-content;
    color: #333333;
    font-size: 18px;
    line-height: 18px;
    border-bottom: solid 1px #fff;
    &:hover {
      color: #409eff;
      border-bottom: solid 1px #409eff;
    }
  }
  .card-info-sec{
    width: 60px;
    padding: 0px 8px;
    line-height: 24px;
    color: #ffffff;
    background-color: #419AEA;
    border-radius: 2px;
    text-align: center;
  }

  .el-card{
    border-radius: 8px;
    border: 1px solid #EBEEF5;
    margin-bottom: 40px;
  }
  .card-cour{
    padding: 14px;
    margin-top: -4px;
    display: flex;
    flex-flow: column;
  }
  .card-cour-hour{
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #999999;
  }
  .card-cour-name{
    line-height: 26px;
    font-size: 16px;
  }
  .el-col-5{
    width: 23.5%;
  }
  .el-col-11{
    width: 49%;
  }
  .el-col-offset-1{
    margin-left: 2%;
  }

  .el-card {
      transition: transform 0.3s ease-out;
      &:hover {
          transform: translateY(-8px);
      }
  }

  span{
    /*多行超出隐藏*/
    /*overflow: hidden;*/
    /*text-overflow:ellipsis;*/
    /*word-break: break-all;*/
    /*display:-webkit-box;*/
    /*-webkit-line-clamp:2;*/
    /*-webkit-box-orient: vertical;*/
    overflow: hidden;
    white-space:nowrap;
    text-overflow:ellipsis;
  }

  >>> .el-loading-mask{
    z-index: 900 !important;
  }
</style>
